// 반복 시도(로그인 / 아이디 찾기 / 비밀번호 찾기)를 일정 횟수 이상 실패하면
// 일정 시간 동안 잠그는 간단한 브루트포스 방지 유틸 (sessionStorage 기반)

export const MAX_TRIES = 5;
export const LOCK_MS = 10 * 60 * 1000; // 10분

const read = (key) => {
  try {
    return JSON.parse(sessionStorage.getItem(key)) || { tries: 0, lockUntil: 0 };
  } catch {
    return { tries: 0, lockUntil: 0 };
  }
};

const write = (key, state) => {
  try { sessionStorage.setItem(key, JSON.stringify(state)); } catch { /* noop */ }
};

export const checkLock = (key) => {
  const { lockUntil } = read(key);
  if (lockUntil && Date.now() < lockUntil) {
    return { locked: true, remainingMin: Math.ceil((lockUntil - Date.now()) / 60000) };
  }
  return { locked: false };
};

export const recordFailure = (key, maxTries = MAX_TRIES, lockMs = LOCK_MS) => {
  const state = read(key);
  if (state.lockUntil && Date.now() >= state.lockUntil) {
    state.tries = 0;
    state.lockUntil = 0;
  }
  state.tries += 1;
  if (state.tries >= maxTries) state.lockUntil = Date.now() + lockMs;
  write(key, state);
  return state;
};

export const resetLock = (key) => write(key, { tries: 0, lockUntil: 0 });
